import { clsxMerge } from '@dreamstack/util'
import Linkify from 'react-linkify'
import { BodyText } from './Texts'

type BodyTextWithLinksProps = { children?: string | null; className?: string }

// Tailwind utility notes:
// - whitespace-pre-line replicates previous tw utility
// - Link color and hover underline use theme color `accentroAqua-full` if present as `text-accentroAqua-full`
//   Fallback to inline style if variant naming differs. Using utility first for purge safety.
export const BodyTextWithLinks = ({
  children,
  className,
}: BodyTextWithLinksProps) => {
  if (!children) return null
  return (
    <BodyText
      className={clsxMerge(
        'whitespace-pre-line [&_a]:no-underline [&_a]:text-accentroAqua-full [&_a:hover]:underline',
        className
      )}
    >
      <Linkify
        hrefDecorator={(url) => {
          try {
            const urlObject = new URL(url)
            if (urlObject.protocol === 'http:') {
              urlObject.protocol = 'https:'
              return urlObject.toString()
            }
          } catch (error) {
            console.error('Error parsing URL', error)
          }
          return url
        }}
      >
        {children}
      </Linkify>
    </BodyText>
  )
}
